module.exports = __webpack_public_path__ + "img/specialeffects-2_en.1aca4a4.jpg";